import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated, isAdmin, logout } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  // Закрываем мобильное меню при изменении маршрута
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  
  // Определяем, является ли текущая страница статической
  const isStaticPage = ['/', '/terms', '/privacy', '/contact'].includes(location.pathname);
  
  // Простой сайдбар для статических страниц
  if (isStaticPage) {
    return null; // Для статических страниц не показываем сайдбар
  }
  
  return (
    <>
      {/* Mobile menu button */}
      <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      {/* Sidebar */}
      <div className={`sidebar ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="sidebar-header">
          <Link to="/" className="app-title">
            <img src="/static/logo-ai.png" alt="AI Report Generator Logo" className="logo" />
            <span className="title-text">AI-Reports.ru</span>
          </Link>
        </div>
        
        <nav className="sidebar-nav">
          <ul className="nav-links">
            {isAuthenticated ? (
              <>
                <li>
                  <Link 
                    to="/profile" 
                    className={location.pathname === '/profile' ? 'active' : ''}
                  >
                    Профиль
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/reports" 
                    className={location.pathname === '/reports' ? 'active' : ''}
                  >
                    Отчеты
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/ticks" 
                    className={location.pathname === '/ticks' ? 'active' : ''}
                  >
                    Тики
                  </Link>
                </li>
                {/* Проверка на админа */}
                {isAdmin && (
                  <li>
                    <Link 
                      to="/admin" 
                      className={location.pathname.startsWith('/admin') ? 'active' : ''}
                    >
                      Админ-панель
                    </Link>
                  </li>
                )}
              </>
            ) : (
              <li>
                <Link 
                  to="/login" 
                  className={location.pathname === '/login' ? 'active' : ''}
                >
                  Войти
                </Link>
              </li>
            )}
          </ul>
        </nav>
        
        {isAuthenticated && user && (
          <div className="user-profile">
            <div className="user-info">
              <div className="user-name">{user.name}</div>
              <div className="user-email">{user.email}</div>
            </div>
            <div className="user-balance">
              <i className="fa fa-cog"></i>
              <span>{user.balance}</span>
            </div>
            <button onClick={handleLogout} className="logout-btn">
              <svg className="logout-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              Выйти
            </button>
          </div>
        )}
        
        {/* Footer links */}
        <div className="sidebar-footer">
          <div className="footer-links-section">
            <h4>Правовая информация</h4>
            <ul className="footer-links">
              <li><Link to="/terms">Условия использования</Link></li>
              <li><Link to="/privacy">Политика конфиденциальности</Link></li>
              <li><Link to="/contact">Связаться с нами</Link></li>
            </ul>
          </div>
          <div className="copyright">
            &copy; {new Date().getFullYear()} Универсальный генератор отчетов
          </div>
        </div>
      </div>
      
      {/* Overlay for mobile */}
      {isMobileMenuOpen && <div className="sidebar-overlay" onClick={toggleMobileMenu}></div>}
    </>
  );
};

export default Sidebar;
